export default __webpack_public_path__ + "static/media/pause.9e889fa4.svg";